import React from 'react'
import classNames from 'classnames'

interface RadioProps {
  children: React.ReactNode
  value: string
  currentValue: string
  onChange: any
  name: string
  centerLabel?: boolean
  buttonAlignment?: 'left' | 'right' | 'top-left' | 'top-right'
  ref?: React.Ref<HTMLInputElement> | undefined
}

interface RadioGroupProps {
  children: React.ReactNode
  column?: boolean
  stack?: boolean
}

export const Radio: React.FC<RadioProps> = React.forwardRef(
  (
    {
      name,
      children,
      value,
      currentValue,
      onChange,
      centerLabel = false,
      buttonAlignment = 'left',
    },
    ref,
  ) => (
    <div className={'radio-button'}>
      <label
        className={classNames({ 'radio-checked': value === currentValue }, { center: centerLabel })}
      >
        <input
          className={buttonAlignment}
          type='radio'
          name={name}
          id={name}
          value={value}
          checked={value === currentValue}
          onChange={onChange}
          ref={ref}
        />
        {children}
      </label>
    </div>
  ),
)

interface CriticalRadioProps {
  name: string
  checked: boolean
  children?: React.ReactNode
  centerLabel?: boolean
  buttonAlignment?: 'left' | 'right' | 'top-left' | 'top-right'
  labelTarget?: Record<string, string>
  buttonActions: Record<string, string | number>
  onClick?: any
}

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

export const CriticalRadio = ({
  name,
  checked,
  children,
  centerLabel = false,
  buttonAlignment,
  labelTarget,
  buttonActions,
  onClick = () => {},
}: CriticalRadioProps) => {
  return (
    <div onClick={onClick} className={'radio-button'}>
      <label
        className={classNames({ 'radio-checked': checked, center: centerLabel })}
        {...labelTarget}
      >
        <input
          {...(buttonAlignment ? { className: buttonAlignment } : {})}
          type='radio'
          name={name}
          readOnly={true}
          checked={checked}
          {...buttonActions}
        />
        {children}
      </label>
    </div>
  )
}

interface SimpleRadioProps {
  name: string
  id: string
  value: string
  checked: boolean
  children: React.ReactNode
}

export const SimpleRadio = ({
  name,
  id,
  value,
  checked,
  className,
  children,
}: SimpleRadioProps) => {
  return (
    <label className={classNames('SimpleRadio', className)} htmlFor={id}>
      <input type='radio' name={name} id={id} value={value} checked={checked} />
      <span>{children}</span>
    </label>
  )
}

const RadioGroup = ({ children, column = false, stack = false }: RadioGroupProps) => (
  <div
    className={classNames(
      { 'radio-group': true },
      { 'radio-group__stack': stack, 'radio-group__column': column },
    )}
  >
    {children}
  </div>
)

export default RadioGroup
